<template>
  <IconSvgBase :class="$style.icon" :view-width="24" :view-height="24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0003 13C13.0003 13.552 12.5523 14 12.0003 14C11.4483 14 11.0003 13.552 11.0003 13V9C11.0003 8.448 11.4483 8 12.0003 8C12.5523 8 13.0003 8.448 13.0003 9V13ZM12.0003 17C11.4483 17 11.0003 16.552 11.0003 16C11.0003 15.448 11.4483 15 12.0003 15C12.5523 15 13.0003 15.448 13.0003 16C13.0003 16.552 12.5523 17 12.0003 17ZM22.5613 16.303L14.8893 3.584C14.2903 2.592 13.2103 2 12.0003 2C10.7903 2 9.7103 2.592 9.1113 3.584L1.4393 16.303C0.871302 17.246 0.854302 18.38 1.3943 19.336C1.9733 20.363 3.0983 21 4.3283 21H19.6723C20.9023 21 22.0273 20.363 22.6063 19.336C23.1463 18.38 23.1293 17.246 22.5613 16.303Z"
    />
  </IconSvgBase>
</template>

<script setup lang="ts">
import IconSvgBase from '@/components/icons/IconSvgBase.vue'
</script>

<style lang="scss" module>
.icon {
  $size: 1em;

  width: $size;
  height: $size;

  &__path {
    color: inherit;
    fill: currentcolor;
  }
}
</style>
